import React from "react";
import { FormProvider } from "react-hook-form";
import { useQuotationPopupForm } from "../hooks/use-quotation-popup-form";

type ContainerPropsType = React.PropsWithChildren<unknown>;
export const QuotationPopupFormContainer: React.FC<ContainerPropsType> = (
    props: ContainerPropsType
) => {
    const { rhForm, handleSubmit } = useQuotationPopupForm();
    return (
        <FormProvider {...rhForm}>
            <form
                data-testid="QuotationPopupFormContainer"
                onSubmit={handleSubmit}
            >
                {props.children}
            </form>
        </FormProvider>
    );
};
